var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9046 6.30156C14.6877 5.73156 16.6827 3.43742 16.6549 0.601562C13.8718 1.17156 11.8768 3.4657 11.9046 6.30156ZM20.4902 7.80901C18.7799 8.66763 17.6034 10.4326 17.6034 12.4766C17.6034 14.9083 19.1505 16.946 21.4004 17.5289C20.2085 20.8641 18.1196 23.4016 16.6527 23.4016C15.3731 23.4016 14.6361 23.1027 13.9858 22.8391L13.9831 22.838C13.4746 22.6311 13.0348 22.4525 12.3773 22.4525C11.72 22.4525 11.2802 22.631 10.7718 22.8374L10.7716 22.8375L10.7708 22.8378C10.1201 23.1021 9.38293 23.4016 8.10151 23.4016C6.00766 23.4016 2.40039 18.2378 2.40039 12.952C2.40039 6.48804 7.51785 6.30156 8.10151 6.30156C9.02803 6.30156 9.68917 6.55251 10.328 6.79512C10.947 7.0303 11.5315 7.25203 12.3773 7.25203C13.2231 7.25203 13.8077 7.0303 14.4266 6.79512C15.0655 6.55251 15.7267 6.30156 16.6532 6.30156C17.0017 6.30156 18.9635 6.37909 20.4902 7.80901Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.0059 5.73423C12.0175 5.66903 12.0319 5.48775 12.0463 5.37813C12.0567 5.24039 12.0716 5.10499 12.0911 4.97195C12.4565 2.46627 14.3944 0.802763 17.0003 0.260681C17.0031 0.174133 17.004 0.0875855 17.0032 0C14.1602 0.582214 12.0986 2.87113 12.0059 5.73423Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogoIcon);
export default __webpack_public_path__ + "static/media/apple-logo-icon.47c31775c9c832c749ebf665fe8b1681.svg";
export { ForwardRef as ReactComponent };